import { CategoryWithParts, IPart } from "../../../models/Part";
import PriceFormat from '../../../utils/priceFormat';
import { DateTime } from "luxon";

interface SmartPriceButtonProps {
  categoryWithParts: CategoryWithParts;
  onPriceSelect: (price: number) => void;
}

export default function SmartPriceButton({ categoryWithParts, onPriceSelect }: SmartPriceButtonProps) {

  const price = categoryWithParts.category.marketDataAveragePrice;

  if (!price) {
    return null;
  }

  const smartPrice = parseFloat((price).toFixed(2));

  return (
    <button
      onClick={() => onPriceSelect(smartPrice)}
      className="border text-white shadow rounded-md p-1 px-2 bg-[#9b0071] hover:bg-[#9b0071]/70 w-20 text-center"
    >
      <span className="font-bold">{PriceFormat(smartPrice)}</span>
    </button>
  );
} 